import { AlertTriangle, BookOpenCheck } from 'lucide-react'
import { Link } from 'react-router-dom'

export function KnowledgeLibrarySkeleton() {
  return (
    <div
      className="aw-knowledge-list"
      aria-label="Loading knowledge documents"
      aria-busy="true"
      role="status"
    >
      {[0, 1, 2, 3].map((item) => (
        <div key={item} className="aw-knowledge-row-skeleton" />
      ))}
    </div>
  )
}

export function KnowledgeLibraryError({ retry }: { retry: () => void }) {
  return (
    <div className="aw-knowledge-empty" role="alert">
      <AlertTriangle className="h-5 w-5" aria-hidden />
      <div>
        <strong>Could not load knowledge documents</strong>
        <p>Your workspace content was not changed. Try loading the library again.</p>
        <button type="button" className="aw-knowledge-empty-action" onClick={retry}>
          Try again
        </button>
      </div>
    </div>
  )
}

export function KnowledgeLibraryEmpty({
  workspaceEmpty,
  loadedCount,
  onCreateManual,
  onClearFilters,
}: {
  workspaceEmpty: boolean
  loadedCount: number
  onCreateManual?: () => void
  onClearFilters?: () => void
}) {
  return (
    <div className="aw-knowledge-empty">
      <BookOpenCheck className="h-5 w-5" aria-hidden />
      <div>
        <strong>
          {workspaceEmpty ? 'No knowledge documents yet' : 'No loaded documents match'}
        </strong>
        <p>
          {workspaceEmpty
            ? 'Create a Manual document in AgentWiki or sync repository and vault sources with the CLI.'
            : `Try a different ownership, source, memory class, or search term in the ${loadedCount} loaded results.`}
        </p>
        <div className="aw-knowledge-empty-actions">
          {workspaceEmpty ? (
            <>
              {onCreateManual && (
                <button
                  type="button"
                  className="aw-knowledge-empty-action"
                  onClick={onCreateManual}
                >
                  New Manual document
                </button>
              )}
              <Link to="/docs/cli" className="aw-knowledge-empty-action">
                Sync sources
              </Link>
            </>
          ) : (
            onClearFilters && (
              <button type="button" className="aw-knowledge-empty-action" onClick={onClearFilters}>
                Clear filters
              </button>
            )
          )}
        </div>
      </div>
    </div>
  )
}
